var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.839,
    height: 18,
    viewBox: "0 0 17.839 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center",
    transform: "translate(-0.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49087",
    "data-name": "Path 49087",
    d: "M11.277,18h-4.5V15.365A6.75,6.75,0,0,1,4.64,14.131L2.357,15.45l-2.25-3.9,2.282-1.316a6.825,6.825,0,0,1,0-2.468L.107,6.45l2.25-3.9L4.64,3.869A6.75,6.75,0,0,1,6.777,2.635V0h4.5V2.635a6.75,6.75,0,0,1,2.137,1.235L15.7,2.55l2.25,3.9L15.664,7.766a6.825,6.825,0,0,1,0,2.468l2.282,1.316-2.25,3.9-2.283-1.318a6.75,6.75,0,0,1-2.137,1.234Zm-3-1.5h1.5V14.23l.563-.146a5.238,5.238,0,0,0,2.432-1.409l.407-.415L15.147,13.4l.75-1.3-1.965-1.135.155-.559a5.286,5.286,0,0,0,0-2.813l-.155-.56L15.9,5.9l-.75-1.3L13.18,5.737l-.407-.412A5.238,5.238,0,0,0,10.34,3.919L9.777,3.77V1.5h-1.5V3.77l-.563.145A5.238,5.238,0,0,0,5.281,5.325l-.407.415L2.907,4.6l-.75,1.3L4.122,7.034l-.155.56a5.286,5.286,0,0,0,0,2.813l.154.559L2.157,12.1l.75,1.3,1.967-1.136.407.415a5.238,5.238,0,0,0,2.432,1.406l.563.145Zm.75-4.5a3,3,0,1,1,3-3A3,3,0,0,1,9.027,12Zm0-4.5a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,9.027,7.5Z",
    fill: "#147aff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/SettingIcon.00c5c411cc54ff3f2104e5646845c597.svg";
export { ForwardRef as ReactComponent };